import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const LeadAgentNoticeDialog = ({ onAccept }) => {
  return (
    <Dialog open fullWidth maxWidth='sm'>
      <DialogTitle>Before you continue, please read and accept</DialogTitle>
      <DialogContent>
        <DialogContentText component='div'>
          <Typography gutterBottom>
            You’re about to enter the platform, where you’ll see clients and commission schedules. This information is
            confidential. Don’t share it.
          </Typography>
          <Typography gutterBottom>
            TechXpander only works if Lead Agents and Clients keep working through the platform. That’s the core of the
            model — it protects your work, the client’s, other Lead Agents’, and ours too. Everyone loses if this isn’t
            followed.
          </Typography>
          <Typography gutterBottom>
            Therefore, please check all clients now. If you see one you’re already working with (or plan to), no
            problem, but stop and contact us first at support@techxpander.com to discuss.
          </Typography>
          <Typography gutterBottom>
            If you don’t report this now, it may lead to termination, removal from the platform, loss of unpaid
            commission, and penalties for the client.
          </Typography>
          <Typography variant='body2' sx={{ mt: 2 }}>
            For more information see clauses 8 and 9 of the&nbsp;
            <Typography
              component='span'
              onClick={() => {
                sessionStorage.setItem('leadAgentNoticeAccepted', 'true');
                window.open('/content/terms', '_blank');
              }}
              sx={{
                textDecoration: 'none',
                color: '#1976d2',
                fontSize: '0.875rem',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Terms & Conditions
            </Typography>
            .
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onAccept} variant='contained' color='primary' autoFocus>
          OK, continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadAgentNoticeDialog;
